import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dtwin-rule-table"
  }, [_vm.targetRuleIndex >= 0 ? _c(VDialog, {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.deleteDialog,
      callback: function ($$v) {
        _vm.deleteDialog = $$v;
      },
      expression: "deleteDialog"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    class: `headline ${_vm.color}--text`
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.deleteConfirmation')) + "\n      ")]), _c(VDivider), _c(VCardActions, [_c(VSpacer), _c('core-button', {
    attrs: {
      "disabled": _vm.deletionInProgress,
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.deleteDialog = false;
        _vm.targetRuleIndex = -1;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.cancel')) + "\n        ")]), _c('core-button', {
    attrs: {
      "disabled": _vm.deletionInProgress,
      "color": _vm.color
    },
    on: {
      "click": function ($event) {
        return _vm.deleteRule(_vm.targetRuleIndex);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.tenant.bridges.deleteButton')) + "\n        ")])], 1)], 1)], 1) : _vm.deletionSelection.length > 0 ? _c(VDialog, {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.deleteDialog,
      callback: function ($$v) {
        _vm.deleteDialog = $$v;
      },
      expression: "deleteDialog"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    class: `headline ${_vm.color}--text`
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.massDeleteDialogTitle')) + "\n      ")]), _vm.deletionInProgress ? _c(VCardText, {
    staticClass: "mt-2"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.massDeleteDialogText')) + "\n        "), _c(VProgressCircular, {
    attrs: {
      "indeterminate": "",
      "color": _vm.color
    }
  })], 1) : _vm._e(), _c(VDivider), _c(VCardActions, [_c(VSpacer), _c('core-button', {
    attrs: {
      "disabled": _vm.deletionInProgress,
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.deleteDialog = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.cancel')) + "}\n        ")]), _c('core-button', {
    attrs: {
      "disabled": _vm.deletionInProgress,
      "color": _vm.color
    },
    on: {
      "click": function ($event) {
        return _vm.deleteSelectedRules();
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.tenant.bridges.deleteButton')) + "\n        ")])], 1)], 1)], 1) : _vm._e(), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "py-0 my-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description mt-2 mb-0 pb-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.text')) + "\n      ")])]), _c(VCol, {
    staticClass: "py-0 my-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.searchLabel'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "single-line": "",
      "hide-details": "",
      "clearable": "",
      "dense": ""
    },
    model: {
      value: _vm.searchTerm,
      callback: function ($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  })], 1), _c(VCol, {
    staticClass: "py-0 my-0",
    attrs: {
      "cols": "12",
      "md": "4",
      "align": "right"
    }
  }, [_c(VSwitch, {
    attrs: {
      "inset": "",
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.includeVDRules')
    },
    model: {
      value: _vm.includeVDRules,
      callback: function ($$v) {
        _vm.includeVDRules = $$v;
      },
      expression: "includeVDRules"
    }
  })], 1), _c(VCol, {
    staticClass: "py-0 my-0",
    attrs: {
      "cols": "12",
      "md": "4",
      "align": "right"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": _vm.isFetchingCommandExecutions
    },
    on: {
      "click": _vm.fetchCommandExecutions
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.loadCommandExecsButton')) + "\n      ")])], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, [_c(VDataTable, {
    attrs: {
      "headers": _vm.tableLocalized.headers,
      "items": _vm.rulesList,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "footer-props": _vm.tableLocalized.footerProps,
      "show-select": _vm.serverItemsLength > 0,
      "item-key": "id"
    },
    on: {
      "update:options": [function ($event) {
        _vm.tableOptions = $event;
      }, _vm.updatePagination]
    },
    scopedSlots: _vm._u([{
      key: "header.geoFences",
      fn: function () {
        return [_c(VIcon, {
          attrs: {
            "small": "",
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geofencing')
          }
        }, [_vm._v("\n            fal fa-map-marker-check\n          ")])];
      },
      proxy: true
    }, {
      key: "header.timeTriggers",
      fn: function () {
        return [_c(VIcon, {
          attrs: {
            "small": "",
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.headline')
          }
        }, [_vm._v("\n            fal fa-alarm-clock\n          ")])];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (props) {
        return [_c('tr', {
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('td', [_c(VSimpleCheckbox, {
          attrs: {
            "value": _vm.deletionSelection.findIndex(i => i.id === props.item.id) >= 0
          },
          on: {
            "input": function ($event) {
              return _vm.deleteRuleToggled(props.item);
            }
          }
        })], 1), _c('td', [_c('div', {
          staticStyle: {
            "margin": "0 auto",
            "text-align": "center"
          }
        }, [_c(VIcon, {
          attrs: {
            "color": props.item.properties.disabled ? 'primary' : _vm.color,
            "size": "16"
          }
        }, [_vm._v("\n                  fal fa-lightbulb" + _vm._s(props.item.properties.disabled ? '-slash' : '') + "\n                ")])], 1)]), _c('td', {
          staticClass: "text-left",
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "260px"
          }
        }, [_vm._v("\n              " + _vm._s(props.item.properties.title) + "\n            ")]), _c('td', [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.detailButtonClicked(props.item);
            }
          }
        }, [_vm._v("\n                fal " + _vm._s(_vm.detailButtonIcon) + "\n              ")]), _vm._v("\n               \n              "), _vm.hasTwinEditPermission ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.targetRuleIndex = props.index;
              _vm.deleteDialog = true;
            }
          }
        }, [_vm._v("\n                fal fa-trash-alt\n              ")]) : _vm._e()], 1), _c('td', [_vm._v("\n              " + _vm._s(props.item.dtwin.title) + "  \n              "), _c('a', {
          attrs: {
            "href": `/#${_vm.baseDetailLink(props.item)}`,
            "target": "_blank"
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          }
        }, [_vm._v("fal fa-external-link")])], 1)]), _c('td', {
          staticClass: "text-right"
        }, [(props.item.properties.geoFences || []).length ? [_c(VIcon, {
          attrs: {
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geofencing'),
            "size": "16"
          }
        }, [_vm._v("\n                  fal fa-check-square\n                ")])] : _vm._e()], 2), _c('td', {
          staticClass: "text-left"
        }, [(props.item.properties.timeTriggers || []).length ? [_c(VIcon, {
          attrs: {
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.headline'),
            "size": "16"
          }
        }, [_vm._v("\n                  fal fa-check-square\n                ")])] : _vm._e()], 2), _c('td', [_vm._v("\n              " + _vm._s(_vm.localizeDate(_vm.get(props.item, 'properties.lastTrigger.time') || null)) + "\n              "), _c('custom-code', [_vm._v(_vm._s(_vm.get(props.item, 'properties.lastTrigger.value', '-')))])], 1), _c('td', [_c('ul', _vm._l(_vm.processedRuleActions(props.item), function (action, i) {
          return _c('li', {
            key: `action_${props.item.id}_${i}`
          }, [_vm._v("\n                  " + _vm._s(action.command) + "\n                  "), _c('small', [_vm._v(_vm._s(action.condition))]), action.lastExecution ? [_c('p', [_vm._v(_vm._s(action.lastExecution))])] : _vm._e()], 2);
        }), 0)])])];
      }
    }, _vm.deletionSelection.length > 0 ? {
      key: "body.append",
      fn: function () {
        return [_c('tr', [_c('td', {
          attrs: {
            "colspan": "7"
          }
        }, [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.detailButtonTitle,
            "prepend-icon": "fa-trash-alt"
          },
          on: {
            "click": function ($event) {
              _vm.deleteDialog = true;
            }
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.deleteSelection')) + "\n              ")])], 1)])];
      },
      proxy: true
    } : null, {
      key: "footer.page-text",
      fn: function (props) {
        return [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.lines')) + " " + _vm._s(props.pageStart) + " - " + _vm._s(props.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + "\n          " + _vm._s(props.itemsLength) + "\n        ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n          ")])];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.deletionSelection,
      callback: function ($$v) {
        _vm.deletionSelection = $$v;
      },
      expression: "deletionSelection"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };